<template lang="html">

  <div class="ofertas">

    <div class="contenedor-ofertas">
      <oferta :key="key" :data="oferta" v-for="(oferta,key) in ofertas.slice(0,5)"></oferta>
    </div>
    <router-link class="link" :to="$t('enlaces.ofertas')">Ver más</router-link>
  </div>
</template>

<script lang="js">

  import oferta from '@/components/view-parts/home/oferta-el';

  import {mapGetters} from 'vuex'

  export default {
    name: 'ofertas-home',
    computed : {
      ...mapGetters({
        ofertas : 'getofertas'
      })
    },
    components: {
      'oferta': oferta
    }
  }

</script>

<style scoped lang="scss">

  .ofertas{
    text-align: left;
  }

  .contenedor-ofertas{
    padding: 0;
  }

</style>


// WEBPACK FOOTER //
// src/components/view-parts/home/ofertas.vue